import { initContract } from "@ts-rest/core";
import { z } from "zod";

import { UpdateableOrganizationType } from "@src/common/types/organizations.type";
import {
  AddAssigneesToTechnologyResponseType,
  DeleteOrganizationUserResponseType,
  GetOrganizationByIdResponseType,
  GetOrganizationTechnologiesResponseType,
  GetOrganizationUsersResponseType,
  UpdateOrganizationResponseType,
} from "@src/resources/organizations/organizations.service";

const c = initContract();

const index = c.router({
  addAssigneesToTechnology: {
    body: z.object({
      technologyId: z.string(),
      userIds: z.array(z.string()),
    }),
    method: "POST",
    path: `/organizations/add-assignees-to-technology`,
    responses: {
      200: c.type<AddAssigneesToTechnologyResponseType>(),
    },
  },

  archiveOrganizationUser: {
    body: z.object({
      userId: z.string(),
    }),
    method: "POST",
    path: `/organizations/delete-user`,
    responses: {
      200: c.type<DeleteOrganizationUserResponseType>(),
    },
  },

  getOrganizationById: {
    method: "GET",
    path: `/organizations/:organizationId`,
    pathParams: z.object({
      organizationId: z.string().transform((value) => Number.parseInt(value, 10)),
    }),
    responses: {
      200: c.type<GetOrganizationByIdResponseType>(),
    },
  },

  getOrganizationTechnologies: {
    method: "GET",
    path: `/organizations/technologies/:organizationId`,
    pathParams: z.object({
      organizationId: z.string().transform((value) => Number.parseInt(value, 10)),
    }),
    responses: {
      200: c.type<GetOrganizationTechnologiesResponseType>(),
    },
  },

  getOrganizationUsers: {
    method: "GET",
    path: `/organizations/users/:organizationId`,
    pathParams: z.object({
      organizationId: z.string().transform((value) => Number.parseInt(value, 10)),
    }),
    responses: {
      200: c.type<GetOrganizationUsersResponseType>(),
    },
  },

  updateOrganization: {
    body: c.type<UpdateableOrganizationType>(),
    method: "POST",
    path: `/organizations/update-name/:organizationId`,
    pathParams: z.object({
      organizationId: z.string().transform((value) => Number.parseInt(value, 10)),
    }),
    responses: {
      200: c.type<UpdateOrganizationResponseType>(),
    },
  },
});

export default index;
